import PropTypes from 'prop-types';

import React, { Component } from 'react';
import isUrl from 'validator/lib/isURL';

import Icon from '../../helper/Icon';

// import {default as Video, Controls, Play, Mute, Seek, Fullscreen, Time, Overlay } from 'react-html5video';
// import 'react-html5video/src/assets/video.css';

export default class PDFCard extends Component {
  static propTypes = {
    cardId: PropTypes.string.isRequired,
    card: PropTypes.object.isRequired
  };

  state = {
    fullScreen: false,
    url: null
  };

  UNSAFE_componentWillMount = () => {
    let url = this.props.card.url;
    if (this.props.card && this.props.card.url.indexOf('scorm') > 0) {
      url = this.setLocalURL(this.props.card.url);
    }
    if (!isUrl(url) || url.indexOf('<iframe') < 0) {
      this.state.noUrl = true;
    }
  };

  componentDidMount() {
    /* $j(this.refs.iframe).iFrameResize({
        log: false,
        heightCalculationMethod: 'taggedElement',
    }); */
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    let url = nextProps.card.url;
    if (nextProps.card && nextProps.card.url.indexOf('scorm') > 0) {
      url = this.setLocalURL(nextProps.card.url);
    }
    if (!isUrl(url) || url.indexOf('<iframe') < 0) {
      this.state.noUrl = true;
    }
  };

  setLocalURL(url) {
    return window.location.origin + '/lyearn/scorm/' + url.split('/scorm/')[1];
  }

  renderIframeOrEmbed = (url) => {
    if (isUrl(url)) {
      return (
        <iframe title="URL Iframe" id="iframe0" ref="iframe" style={styles.iframe} src={url}>
          Iframe is not supported
        </iframe>
      );
    }
    if (url.indexOf('<iframe') > -1) {
      return <div className="embedIframeContainer" dangerouslySetInnerHTML={{ __html: url }} />;
    }
    return <div style={styles.noUrl}>Unsupported URL/Embed code provided</div>;
  };

  render() {
    // console.log(this.props);
    let url = this.props.card.url;
    if (this.props.card && this.props.card.url.indexOf('scorm') > 0) {
      url = this.setLocalURL(this.props.card.url);
    }
    return (
      <div style={this.props.fullScreen ? styles.containerFullScreen : styles.container}>
        {this.renderIframeOrEmbed(url)}
        {!this.props.isPreview && !this.state.noUrl && (
          <div style={styles.fullScreenBtn} onClick={this.props.toggleFullscreen}>
            <Icon
              icon={this.props.fullScreen ? 'fullscreen-exit' : 'fullscreen'}
              size="1.5em"
              fill="rgba(0,0,0,0.64)"
            />
          </div>
        )}
      </div>
    );
  }
}

const styles = {
  container: {
    justifyContent: 'center',
    padding: '0px 40px 0px',
    position: 'relative'
  },
  containerFullScreen: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    height: '100%',
    width: '100%',
    zIndex: '1000',
    justifyContent: 'center',
    padding: '0px 40px 0px',
    boxSizing: 'border-box',
    backgroundColor: '#fff'
  },
  iframe: {
    width: '100%',
    height: '100%',
    minHeight: 'calc(100vh - 185px)',
    border: 'none'
  },
  fullScreenBtn: {
    height: '25px',
    width: '25px',
    backgroundColor: '#fff',
    position: 'absolute',
    bottom: '5px',
    right: '5px',
    cursor: 'pointer',
    zIndex: 2
  },
  noUrl: {
    width: '85%',
    maxWidth: '809px',
    margin: '0px auto',
    backgroundColor: 'transparent',
    zIndex: '2',
    paddingTop: '0px',
    height: '60vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '25px'
  }
};
